/**
 * `src/meta` public surface. Owner: Meta/Economy (P5): balance, `grant()` (the ONLY function that changes economy
 * state), items, energy, virtues, Послушания, «Житие», «Часы дня», `sim:econ`. Registers `services.rewards` and
 * `services.economy` in `onBoot`.
 */
import type { FeatureModule } from '../shared';
import { economySlice } from './save';
import { metaScreens } from './screens';
import { installEconomy } from './service';

export const meta: FeatureModule = {
  key: 'meta',
  slices: [economySlice],
  screens: metaScreens,
  onBoot: installEconomy,
  debugApi: () => ({ econ: {} }),
};

export { economySlice, type EconomySave } from './save';
